<script>
import moment from 'moment';
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CustomerService from '@/services/customer'

moment.locale('pt-BR');

export default {
  page: {
    title: "Clientes",
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Clientes",
      loading: false,
      customers: [],
      
      searchValue: '',
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      customerSelected: '',

      showModal: false,
      searchEmptyField: false,

      fields: [
        { key: 'name', sortable: true, label: 'Cliente' },
        { key: 'documentNumber', sortable: true, label: 'CNPJ' },
        { key: 'email', sortable: true, label: 'E-mail' },
        { key: 'status', sortable: true, label: 'Status' },
        { key: 'phoneNumber', sortable: true, label: 'Telefone' },
        { key: 'city', sortable: true, label: 'Cidade/UF', formatter: (value, key, item) => {
            return `${item.city}/${item.state}`;
          }
        },
        { key: 'sellerName', sortable: true, label: 'Vendedor' },
        { key: 'createdAt', sortable: true, label: 'Data Cadastro', formatter: (value) => {
          return moment(value).format('DD/MM/YYYY HH:mm');
        } },
      ],
    }
  },
  computed: {
    rows() {
      return this.customers.length;
    }
  },
  methods: {
    loadCustomers(showLoading = true, page = 1, term = '') {
      if (showLoading) {
        this.loading = true;
      }

      CustomerService.getSellerCustomers(page, term)
        .then(res => {
          this.loading = false;

          this.customers = res.data.customers;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.loadCustomers(true, this.currentPage);
    },
    search() {
      this.searchEmptyField = false,
      this.loadCustomers(true, 1, this.searchValue);
    },
    changeSearch() {
      if (this.searchValue === '' && !this.searchEmptyField) {
        this.searchEmptyField = true;
        this.loadCustomers(true, 1, this.searchValue);
      }
    },
    exportData() {
      this.loading = true;

      CustomerService.exportSellerCustomers(this.searchValue).then(res => {
        this.loading = false;
        
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'ClientesVendedor.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        this.loading = false;
      })
    },
  },
  mounted() {
    this.loadCustomers();
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <div class="row mb-2 align-items-center">
              <div class="col-sm-12 col-md-6 col-lg-6">
                <div class="mr-2 mb-2">
                  <div class="position-relative search-input">
                    <form @submit.prevent="search" class="align-items-center">
                      <input
                        type="text"
                        class="form-control"
                        v-model="searchValue"
                        v-on:keyup="changeSearch"
                        placeholder="Nome do usuário ou razão social do cliente..."
                      />

                      <button type="submit" class="btn btn-primary" v-if="!loading">
                        Pesquisar
                      </button>

                      <a href="javascript:void(0);" class="text-primary" v-if="loading">
                        <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                      </a>
                    </form>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="row mb-2">
              <div class="col-lg-12 mb-2">
                <form @submit.prevent="search" class="align-items-center mb-2">
                  <div class="row">
                    <div class="col-lg-6 col-sm-12">
                      <div class="form-group">
                        <label>Pesquisar Cliente</label>
                        <input
                          type="text"
                          v-model="searchValue"
                          class="form-control"
                          placeholder="Razão social ou CNPJ do cliente..."
                          v-on:keyup="changeSearch"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="button-search">
                    <b-button type="submit" variant="primary" v-if="!loading">Pesquisar</b-button>
                    <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                    <a href="javascript:void(0);" class="text-primary" v-if="loading">
                      <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                    </a>
                  </div>
                </form>
              </div>
            </div>

            <div v-if="customers">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="customers"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template v-slot:cell(status)="row">
                  <span
                    class="badge badge-pill badge-soft-success font-size-12"
                    :class=" {
                      'badge-soft-warning': row.item.status === 'pending',
                      'badge-soft-danger': row.item.status === 'rejected',
                    }"
                  >{{row.item.statusDescription}}</span>
                </template>
              </b-table>

              <div class="row justify-content-md-between align-items-md-center mt-4">
                <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>
                <!-- end col-->
                <div class="col-xl-5">
                  <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                    <b-pagination
                      v-model="currentPage" 
                      :total-rows="count"
                      :per-page="perPage"
                      @input="onPageChange"
                    ></b-pagination>
                  </div>
                </div>
                <!-- end col-->
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss">
  .search-input form {
    display: flex;
    flex-direction: row;

    .btn {
      margin-left: 10px;
    }
  }
</style>